module.exports = __webpack_public_path__ + "img/12-3.2bdc4e50.jpg";